export default __webpack_public_path__ + "static/media/product1.4ebbff27.png";